import { Typography } from '@mui/material';
import React from 'react';

import { StepComponentProps } from 'components/Flow/RenderMachine';
import config from 'config';

import { Layout } from './Components/Layout';

export const NonUS = ({ send }: StepComponentProps) => (
  <Layout title="Non-US nonprofit organization" send={send}>
    <Typography variant="h4" fontWeight={500} lineHeight="38px" mb={3}>
      Guidelines for Non-US Organizations
    </Typography>
    <Typography fontSize={15} lineHeight="38px" mb={3}>
      If your organization is based outside the United States, please go to the{' '}
      <a target="_blank" href="/register" style={{ textDecoration: 'underline' }}>
        Claim Page
      </a>{' '}
      and select the correct country where your organization is located. Complete the registration
      process and if you encounter any issues or need assistance, don’t hesitate to{' '}
      <a
        href={`mailto:${config.nonprofitSuccessTeamEmail}`}
        style={{ textDecoration: 'underline' }}
      >
        contact support
      </a>
      . Our team is here to help with any questions or concerns you may have.
    </Typography>
  </Layout>
);
